/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.9.4.0 (NJsonSchema v10.3.1.0 (Newtonsoft.Json v12.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import authInstance from '../authInstance';
import { apiRequest } from '../authConfig';
import { InteractionRequiredAuthError } from '@azure/msal-common';
export class ApiClientBase {

    protected transformOptions = async (options: RequestInit): Promise<RequestInit> => {
        try {
            let accessToken = (await authInstance.acquireTokenSilent({
                ...apiRequest, account: authInstance.getActiveAccount()!
            })).accessToken
    
            options.headers = {
                ...options.headers,
                Authorization: 'Bearer ' + accessToken,
            };
        } catch (err) {
            if (err instanceof InteractionRequiredAuthError) {
                await authInstance.acquireTokenRedirect(apiRequest)
            }
            console.log(err);
        }
        return Promise.resolve(options);
    };
}

export class ConfigurationClient extends ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    get(): Promise<ConfigurationSettingsResponseDTO> {
        let url_ = this.baseUrl + "/api/configuration";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<ConfigurationSettingsResponseDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ConfigurationSettingsResponseDTO>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    set(body: ConfigurationSettingsRequestDTO | undefined): Promise<ConfigurationSettingsResponseDTO> {
        let url_ = this.baseUrl + "/api/configuration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSet(_response);
        });
    }

    protected processSet(response: Response): Promise<ConfigurationSettingsResponseDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ConfigurationSettingsResponseDTO>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @return Success
     */
    getFake(): Promise<ModemIpSettingEclypseIpSettingReportedTwinDTOProblemDetailsHeartbeatDTOLogMessageDTOTuple> {
        let url_ = this.baseUrl + "/api/configuration/fake";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetFake(_response);
        });
    }

    protected processGetFake(response: Response): Promise<ModemIpSettingEclypseIpSettingReportedTwinDTOProblemDetailsHeartbeatDTOLogMessageDTOTuple> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ModemIpSettingEclypseIpSettingReportedTwinDTOProblemDetailsHeartbeatDTOLogMessageDTOTuple>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ModemIpSettingEclypseIpSettingReportedTwinDTOProblemDetailsHeartbeatDTOLogMessageDTOTuple>(<any>null);
    }
}

export class EmailCheckClient extends ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    checkEmail(body: UserEmail | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/emailcheck/email-check";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCheckEmail(_response);
        });
    }

    protected processCheckEmail(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }
}

export class ModemsClient extends ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getManyAll(): Promise<ModemWithOrgSiteResponseDTO[]> {
        let url_ = this.baseUrl + "/api/modems";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetManyAll(_response);
        });
    }

    protected processGetManyAll(response: Response): Promise<ModemWithOrgSiteResponseDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ModemWithOrgSiteResponseDTO[]>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @return Success
     */
    get2(id: string | null): Promise<ModemWithOrgSiteResponseDTO> {
        let url_ = this.baseUrl + "/api/modems/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet2(_response);
        });
    }

    protected processGet2(response: Response): Promise<ModemWithOrgSiteResponseDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ModemWithOrgSiteResponseDTO>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(id: string | null, body: ModemRequestDTO | undefined): Promise<ModemResponseDTO> {
        let url_ = this.baseUrl + "/api/modems/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<ModemResponseDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ModemResponseDTO>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param requestedType (optional) 
     * @return Success
     */
    getDeviceTwin(id: string | null, requestedType: DeviceTwinOrHeartbeatRequestedType | undefined): Promise<ModemDeviceTwinResponseDTO> {
        let url_ = this.baseUrl + "/api/modems/{id}/device-twin?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (requestedType === null)
            throw new Error("The parameter 'requestedType' cannot be null.");
        else if (requestedType !== undefined)
            url_ += "requestedType=" + encodeURIComponent("" + requestedType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetDeviceTwin(_response);
        });
    }

    protected processGetDeviceTwin(response: Response): Promise<ModemDeviceTwinResponseDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ModemDeviceTwinResponseDTO>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param requestedType (optional) 
     * @param body (optional) 
     * @return Success
     */
    getDeviceTwins(requestedType: DeviceTwinOrHeartbeatRequestedType | undefined, body: ModemHeartbeatsRequestDTO | undefined): Promise<ModemDeviceTwinResponseDTO[]> {
        let url_ = this.baseUrl + "/api/modems/device-twins?";
        if (requestedType === null)
            throw new Error("The parameter 'requestedType' cannot be null.");
        else if (requestedType !== undefined)
            url_ += "requestedType=" + encodeURIComponent("" + requestedType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetDeviceTwins(_response);
        });
    }

    protected processGetDeviceTwins(response: Response): Promise<ModemDeviceTwinResponseDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ModemDeviceTwinResponseDTO[]>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param requestedType (optional) 
     * @return Success
     */
    getHeartbeat(id: string | null, requestedType: DeviceTwinOrHeartbeatRequestedType | undefined): Promise<ModemHeartbeatResponseDTO> {
        let url_ = this.baseUrl + "/api/modems/{id}/heartbeat?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (requestedType === null)
            throw new Error("The parameter 'requestedType' cannot be null.");
        else if (requestedType !== undefined)
            url_ += "requestedType=" + encodeURIComponent("" + requestedType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetHeartbeat(_response);
        });
    }

    protected processGetHeartbeat(response: Response): Promise<ModemHeartbeatResponseDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ModemHeartbeatResponseDTO>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param requestedType (optional) 
     * @param body (optional) 
     * @return Success
     */
    getHeartbeats(requestedType: DeviceTwinOrHeartbeatRequestedType | undefined, body: ModemHeartbeatsRequestDTO | undefined): Promise<ModemHeartbeatResponseDTO[]> {
        let url_ = this.baseUrl + "/api/modems/heartbeats?";
        if (requestedType === null)
            throw new Error("The parameter 'requestedType' cannot be null.");
        else if (requestedType !== undefined)
            url_ += "requestedType=" + encodeURIComponent("" + requestedType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetHeartbeats(_response);
        });
    }

    protected processGetHeartbeats(response: Response): Promise<ModemHeartbeatResponseDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ModemHeartbeatResponseDTO[]>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    provisionModem(body: ModemProvisioningRequestDTO | undefined): Promise<ModemProvisioningResponseDTO> {
        let url_ = this.baseUrl + "/api/modems/provision-new";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processProvisionModem(_response);
        });
    }

    protected processProvisionModem(response: Response): Promise<ModemProvisioningResponseDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : <ModemProvisioningResponseDTO>JSON.parse(_responseText, this.jsonParseReviver);
            return result201;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @return Success
     */
    getPassword(id: string | null): Promise<ModemPasswordResponseDTO> {
        let url_ = this.baseUrl + "/api/modems/{id}/admin-password";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPassword(_response);
        });
    }

    protected processGetPassword(response: Response): Promise<ModemPasswordResponseDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ModemPasswordResponseDTO>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @return Success
     */
    createNewPassword(id: string | null): Promise<void> {
        let url_ = this.baseUrl + "/api/modems/{id}/admin-password";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateNewPassword(_response);
        });
    }

    protected processCreateNewPassword(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    pauseSim(id: string | null, body: ModemPauseSimRequestDTO | undefined): Promise<ModemSimStateResponseDTO> {
        let url_ = this.baseUrl + "/api/modems/{id}/sim/pause-sim";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPauseSim(_response);
        });
    }

    protected processPauseSim(response: Response): Promise<ModemSimStateResponseDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ModemSimStateResponseDTO>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }
}

export class OrganizationsClient extends ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getMany(): Promise<OrganizationResponseDTO[]> {
        let url_ = this.baseUrl + "/api/organizations";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetMany(_response);
        });
    }

    protected processGetMany(response: Response): Promise<OrganizationResponseDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <OrganizationResponseDTO[]>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: OrganizationRequestDTO | undefined): Promise<OrganizationResponseDTO> {
        let url_ = this.baseUrl + "/api/organizations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<OrganizationResponseDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : <OrganizationResponseDTO>JSON.parse(_responseText, this.jsonParseReviver);
            return result201;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @return Success
     */
    get3(id: string): Promise<OrganizationResponseDTO> {
        let url_ = this.baseUrl + "/api/organizations/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet3(_response);
        });
    }

    protected processGet3(response: Response): Promise<OrganizationResponseDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <OrganizationResponseDTO>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update2(id: string, body: OrganizationRequestDTO | undefined): Promise<OrganizationResponseDTO> {
        let url_ = this.baseUrl + "/api/organizations/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate2(_response);
        });
    }

    protected processUpdate2(response: Response): Promise<OrganizationResponseDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <OrganizationResponseDTO>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @return Success
     */
    delete(id: string): Promise<void> {
        let url_ = this.baseUrl + "/api/organizations/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @return Success
     */
    addModem(id: string, modemId: string | null): Promise<void> {
        let url_ = this.baseUrl + "/api/organizations/{id}/modems/{modemId}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (modemId === undefined || modemId === null)
            throw new Error("The parameter 'modemId' must be defined.");
        url_ = url_.replace("{modemId}", encodeURIComponent("" + modemId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAddModem(_response);
        });
    }

    protected processAddModem(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @return Success
     */
    removeModem(id: string, modemId: string | null): Promise<void> {
        let url_ = this.baseUrl + "/api/organizations/{id}/modems/{modemId}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (modemId === undefined || modemId === null)
            throw new Error("The parameter 'modemId' must be defined.");
        url_ = url_.replace("{modemId}", encodeURIComponent("" + modemId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRemoveModem(_response);
        });
    }

    protected processRemoveModem(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @return Success
     */
    getAllModemsAll(id: string): Promise<ModemWithOrgSiteResponseDTO[]> {
        let url_ = this.baseUrl + "/api/organizations/{id}/modems";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllModemsAll(_response);
        });
    }

    protected processGetAllModemsAll(response: Response): Promise<ModemWithOrgSiteResponseDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ModemWithOrgSiteResponseDTO[]>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @return Success
     */
    getManyUsersAll(id: string): Promise<UserWithOrganizationResponseDTO[]> {
        let url_ = this.baseUrl + "/api/organizations/{id}/users";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetManyUsersAll(_response);
        });
    }

    protected processGetManyUsersAll(response: Response): Promise<UserWithOrganizationResponseDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <UserWithOrganizationResponseDTO[]>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @return Success
     */
    addUser(id: string, userId: string | null): Promise<UserResponseDTO> {
        let url_ = this.baseUrl + "/api/organizations/{id}/users/{userId}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAddUser(_response);
        });
    }

    protected processAddUser(response: Response): Promise<UserResponseDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <UserResponseDTO>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @return Success
     */
    deleteUser(id: string, userId: string): Promise<void> {
        let url_ = this.baseUrl + "/api/organizations/{id}/users/{userId}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteUser(_response);
        });
    }

    protected processDeleteUser(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @return Success
     */
    getAllSubgroups(id: string): Promise<SubGroupResponseDTO[]> {
        let url_ = this.baseUrl + "/api/organizations/{id}/subgroups";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllSubgroups(_response);
        });
    }

    protected processGetAllSubgroups(response: Response): Promise<SubGroupResponseDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <SubGroupResponseDTO[]>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @return Success
     */
    getAllSites(id: string): Promise<SiteResponseDTO[]> {
        let url_ = this.baseUrl + "/api/organizations/{id}/sites";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllSites(_response);
        });
    }

    protected processGetAllSites(response: Response): Promise<SiteResponseDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <SiteResponseDTO[]>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @return Success
     */
    addEmail(id: string, email: string | null): Promise<void> {
        let url_ = this.baseUrl + "/api/organizations/{id}/email-whitelist/{email}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (email === undefined || email === null)
            throw new Error("The parameter 'email' must be defined.");
        url_ = url_.replace("{email}", encodeURIComponent("" + email));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAddEmail(_response);
        });
    }

    protected processAddEmail(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @return Success
     */
    removeEmail(id: string, email: string | null): Promise<void> {
        let url_ = this.baseUrl + "/api/organizations/{id}/email-whitelist/{email}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (email === undefined || email === null)
            throw new Error("The parameter 'email' must be defined.");
        url_ = url_.replace("{email}", encodeURIComponent("" + email));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRemoveEmail(_response);
        });
    }

    protected processRemoveEmail(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @return Success
     */
    getAllWhitelistedEmails(id: string): Promise<EmailWhitelistResponseDTO[]> {
        let url_ = this.baseUrl + "/api/organizations/{id}/email-whitelist";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllWhitelistedEmails(_response);
        });
    }

    protected processGetAllWhitelistedEmails(response: Response): Promise<EmailWhitelistResponseDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <EmailWhitelistResponseDTO[]>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }
}

export class RelayApiClient extends ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param modemHostId (optional) 
     * @param batchId (optional) 
     * @param path (optional) 
     * @return Success
     */
    postForwardRequest(modemHostId: string | null | undefined, batchId: string | undefined, path: string | null | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/relayapi/forwardrequest?";
        if (modemHostId !== undefined && modemHostId !== null)
            url_ += "modemHostId=" + encodeURIComponent("" + modemHostId) + "&";
        if (batchId === null)
            throw new Error("The parameter 'batchId' cannot be null.");
        else if (batchId !== undefined)
            url_ += "batchId=" + encodeURIComponent("" + batchId) + "&";
        if (path !== undefined && path !== null)
            url_ += "path=" + encodeURIComponent("" + path) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPostForwardRequest(_response);
        });
    }

    protected processPostForwardRequest(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <string>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }
}

export class SitesClient extends ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getMany2(): Promise<SiteResponseDTO[]> {
        let url_ = this.baseUrl + "/api/sites";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetMany2(_response);
        });
    }

    protected processGetMany2(response: Response): Promise<SiteResponseDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <SiteResponseDTO[]>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create2(body: SiteRequestDTO | undefined): Promise<SiteResponseDTO> {
        let url_ = this.baseUrl + "/api/sites";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreate2(_response);
        });
    }

    protected processCreate2(response: Response): Promise<SiteResponseDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : <SiteResponseDTO>JSON.parse(_responseText, this.jsonParseReviver);
            return result201;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @return Success
     */
    get4(id: string): Promise<SiteResponseDTO> {
        let url_ = this.baseUrl + "/api/sites/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet4(_response);
        });
    }

    protected processGet4(response: Response): Promise<SiteResponseDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <SiteResponseDTO>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update3(id: string, body: SiteRequestDTO | undefined): Promise<SiteResponseDTO> {
        let url_ = this.baseUrl + "/api/sites/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate3(_response);
        });
    }

    protected processUpdate3(response: Response): Promise<SiteResponseDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <SiteResponseDTO>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @return Success
     */
    delete2(id: string): Promise<void> {
        let url_ = this.baseUrl + "/api/sites/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDelete2(_response);
        });
    }

    protected processDelete2(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @return Success
     */
    addModem2(id: string, modemId: string | null): Promise<void> {
        let url_ = this.baseUrl + "/api/sites/{id}/modems/{modemId}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (modemId === undefined || modemId === null)
            throw new Error("The parameter 'modemId' must be defined.");
        url_ = url_.replace("{modemId}", encodeURIComponent("" + modemId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAddModem2(_response);
        });
    }

    protected processAddModem2(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @return Success
     */
    removeModem2(id: string, modemId: string | null): Promise<void> {
        let url_ = this.baseUrl + "/api/sites/{id}/modems/{modemId}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (modemId === undefined || modemId === null)
            throw new Error("The parameter 'modemId' must be defined.");
        url_ = url_.replace("{modemId}", encodeURIComponent("" + modemId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRemoveModem2(_response);
        });
    }

    protected processRemoveModem2(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @return Success
     */
    getAllModems(id: string): Promise<ModemWithOrgSiteResponseDTO[]> {
        let url_ = this.baseUrl + "/api/sites/{id}/modems";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllModems(_response);
        });
    }

    protected processGetAllModems(response: Response): Promise<ModemWithOrgSiteResponseDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ModemWithOrgSiteResponseDTO[]>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }
}

export class SubGroupsClient extends ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    get5(id: string): Promise<SubGroupResponseDTO> {
        let url_ = this.baseUrl + "/api/subgroups/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet5(_response);
        });
    }

    protected processGet5(response: Response): Promise<SubGroupResponseDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <SubGroupResponseDTO>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update4(id: string, body: SubGroupUpdateRequestDTO | undefined): Promise<SubGroupResponseDTO> {
        let url_ = this.baseUrl + "/api/subgroups/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate4(_response);
        });
    }

    protected processUpdate4(response: Response): Promise<SubGroupResponseDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <SubGroupResponseDTO>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @return Success
     */
    delete3(id: string): Promise<void> {
        let url_ = this.baseUrl + "/api/subgroups/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDelete3(_response);
        });
    }

    protected processDelete3(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create3(body: SubGroupRequestDTO | undefined): Promise<SubGroupResponseDTO> {
        let url_ = this.baseUrl + "/api/subgroups";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreate3(_response);
        });
    }

    protected processCreate3(response: Response): Promise<SubGroupResponseDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : <SubGroupResponseDTO>JSON.parse(_responseText, this.jsonParseReviver);
            return result201;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @return Success
     */
    getAllModems2(id: string): Promise<ModemWithOrgSiteResponseDTO[]> {
        let url_ = this.baseUrl + "/api/subgroups/{id}/modems";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllModems2(_response);
        });
    }

    protected processGetAllModems2(response: Response): Promise<ModemWithOrgSiteResponseDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ModemWithOrgSiteResponseDTO[]>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @return Success
     */
    addModem3(id: string, modemId: string | null): Promise<void> {
        let url_ = this.baseUrl + "/api/subgroups/{id}/modems/{modemId}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (modemId === undefined || modemId === null)
            throw new Error("The parameter 'modemId' must be defined.");
        url_ = url_.replace("{modemId}", encodeURIComponent("" + modemId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAddModem3(_response);
        });
    }

    protected processAddModem3(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @return Success
     */
    removeModem3(id: string, modemId: string | null): Promise<void> {
        let url_ = this.baseUrl + "/api/subgroups/{id}/modems/{modemId}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (modemId === undefined || modemId === null)
            throw new Error("The parameter 'modemId' must be defined.");
        url_ = url_.replace("{modemId}", encodeURIComponent("" + modemId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRemoveModem3(_response);
        });
    }

    protected processRemoveModem3(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @return Success
     */
    addUser2(id: string, userId: string): Promise<void> {
        let url_ = this.baseUrl + "/api/subgroups/{id}/users/{userId}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAddUser2(_response);
        });
    }

    protected processAddUser2(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @return Success
     */
    removeUser(id: string, userId: string): Promise<void> {
        let url_ = this.baseUrl + "/api/subgroups/{id}/users/{userId}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRemoveUser(_response);
        });
    }

    protected processRemoveUser(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @return Success
     */
    getManyUsers(id: string): Promise<UserResponseDTO[]> {
        let url_ = this.baseUrl + "/api/subgroups/{id}/users";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetManyUsers(_response);
        });
    }

    protected processGetManyUsers(response: Response): Promise<UserResponseDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <UserResponseDTO[]>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }
}

export class UsersClient extends ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getMany3(): Promise<UserWithOrganizationResponseDTO[]> {
        let url_ = this.baseUrl + "/api/users";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetMany3(_response);
        });
    }

    protected processGetMany3(response: Response): Promise<UserWithOrganizationResponseDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <UserWithOrganizationResponseDTO[]>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @return Success
     */
    get6(id: string): Promise<UserWithOrganizationResponseDTO> {
        let url_ = this.baseUrl + "/api/users/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet6(_response);
        });
    }

    protected processGet6(response: Response): Promise<UserWithOrganizationResponseDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <UserWithOrganizationResponseDTO>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @return Success
     */
    delete4(id: string): Promise<void> {
        let url_ = this.baseUrl + "/api/users/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDelete4(_response);
        });
    }

    protected processDelete4(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update5(userId: string, body: AdminUserRequestDTO | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/users/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate5(_response);
        });
    }

    protected processUpdate5(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @return Success
     */
    persistUser(): Promise<void> {
        let url_ = this.baseUrl + "/api/users/persist-user";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPersistUser(_response);
        });
    }

    protected processPersistUser(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }
}

export interface DeviceEndpointSetting {
    readonly tag?: number;
    readonly isEclypse?: boolean;
    readonly isModem?: boolean;
}

export interface Version {
    readonly major?: number;
    readonly minor?: number;
    readonly build?: number;
    readonly revision?: number;
    readonly majorRevision?: number;
    readonly minorRevision?: number;
}

export interface ConfigurationSettingsResponseDTO {
    readonly cloudEndpoint: string;
    readonly simulatorToRemoteIpMap: { [key: string]: DeviceEndpointSetting; };
    version: Version;
}

export interface ProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;
}

export interface StringFSharpOption {
    readonly value?: string | undefined;
}

export interface ConfigurationSettingsRequestDTO {
    cloudEndpoint?: string | undefined;
    simulatorToRemoteIpMap?: { [key: string]: DeviceEndpointSetting; } | undefined;
}

export interface ModemIpSetting {
    readonly remoteIp: string;
    readonly modemHostId: string;
}

export interface EclypseIpSetting {
    readonly remoteIp: string;
    readonly modemHostId: string;
    readonly nLightId: string;
}

export interface ReportedTwinGatewayDTO {
    deviceId: string;
    ipAddress: string;
    firmware: string;
    label: string;
    webServerPort: number;
    capabilities: string;
}

export interface ReportedTwinDTO {
    modemId: string;
    acuityIoTClientVersion: string;
    appFirmware: string;
    deviceState: string;
    serialNumber: number;
    bootloaderVersion: string;
    imei: string | undefined;
    imsi: string | undefined;
    iccid: string | undefined;
    gateways: ReportedTwinGatewayDTO[];
}

export interface HeartbeatDTO {
    readonly mobileSignalStrength: number;
    readonly lastOnlineTime: IsoDateString;
}

export interface LogMessageDTO {
    exceptionMessage: string | undefined;
    readonly message: string;
    readonly level: string;
    readonly loggerName: string;
    readonly timestamp: IsoDateString;
}

export interface ModemIpSettingEclypseIpSettingReportedTwinDTOProblemDetailsHeartbeatDTOLogMessageDTOTuple {
    item1?: ModemIpSetting;
    item2?: EclypseIpSetting;
    item3?: ReportedTwinDTO;
    item4?: ProblemDetails;
    item5?: HeartbeatDTO;
    item6?: LogMessageDTO;
}

export interface UserEmail {
    email?: string | undefined;
}

export interface GuidFSharpOption {
    readonly value?: string;
}

export interface ModemWithOrgSiteResponseDTO {
    readonly modemHostId: string;
    organizationId: string | undefined;
    siteId: string | undefined;
    readonly label: string;
    readonly created: IsoDateString;
    readonly createdBy: string;
    readonly lastUpdated: IsoDateString;
    readonly lastUpdatedBy: string;
    readonly remoteConnectivityEnabled: boolean;
    readonly ipAddress: string;
    notes: string | undefined;
    orderNumber: string | undefined;
    modemType: number | undefined;
}

export interface BooleanFSharpOption {
    readonly value?: boolean;
}

export interface ModemRequestDTO {
    label?: string | undefined;
    notes?: string | undefined;
    remoteConnectivityEnabled?: boolean | undefined;
    orderNumber?: string | undefined;
}

export interface ModemResponseDTO {
    readonly modemHostId: string;
    readonly label: string;
    readonly created: IsoDateString;
    readonly createdBy: string;
    readonly lastUpdated: IsoDateString;
    readonly lastUpdatedBy: string;
    readonly remoteConnectivityEnabled: boolean;
    readonly ipAddress: string;
    notes: string | undefined;
    orderNumber: string | undefined;
}

export enum DeviceTwinOrHeartbeatRequestedType {
    _0 = 0,
    _1 = 1,
}

export interface DeviceTwinResponse {
    readonly tag?: number;
    readonly isSimple?: boolean;
    readonly isComplete?: boolean;
}

export interface DeviceTwinResponseFSharpOption {
    value?: DeviceTwinResponse;
}

export interface ModemDeviceTwinResponseDTO {
    readonly modemHostId: string;
    deviceTwin: DeviceTwinResponse | undefined;
}

export interface ModemHeartbeatsRequestDTO {
    modemIds: string[];
}

export interface HeartbeatResponse {
    readonly tag?: number;
    readonly isSimple?: boolean;
    readonly isComplete?: boolean;
}

export interface HeartbeatResponseFSharpOption {
    value?: HeartbeatResponse;
}

export interface ModemHeartbeatResponseDTO {
    readonly modemHostId: string;
    heartbeat: HeartbeatResponse | undefined;
}

export interface ModemProvisioningRequestDTO {
    label?: string | undefined;
    orderNumber?: string | undefined;
}

export interface ModemProvisioningResponseDTO {
    readonly modemHostId: string;
    readonly label: string;
    readonly created: IsoDateString;
    readonly createdBy: string;
    readonly lastUpdated: IsoDateString;
    readonly lastUpdatedBy: string;
    readonly ipAddress: string;
    readonly connectionString: string;
    organizationId: string | undefined;
    agencyNumber: string | undefined;
}

export interface ModemPasswordResponseDTO {
    password: string;
}

export interface ModemPauseSimRequestDTO {
    pause: boolean;
}

export interface ModemSimStateResponseDTO {
    newState: string;
}

export interface OrganizationResponseDTO {
    externalId: string;
    name: string;
    agencyNumber: string | undefined;
    created: IsoDateString;
    createdBy: string;
    lastUpdated: IsoDateString;
    lastUpdatedBy: string;
}

export interface OrganizationRequestDTO {
    name?: string | undefined;
    agencyNumber?: string | undefined;
}

export interface Role {
    readonly tag?: number;
    readonly isDefault?: boolean;
    readonly isGlobalAdmin?: boolean;
    readonly isGlobalMember?: boolean;
    readonly isRemoteDeviceManufacturing?: boolean;
    readonly isOrganizationAdmin?: boolean;
    readonly isOrganizationMember?: boolean;
    readonly isOperator?: boolean;
}

export interface UserOrganizationResponseDTO {
    externalId: string;
}

export interface UserOrganizationResponseDTOFSharpOption {
    value?: UserOrganizationResponseDTO;
}

export interface UserWithOrganizationResponseDTO {
    userName: string;
    displayName: string;
    givenName: string;
    surname: string;
    creationDate: IsoDateString;
    lastUpdate: IsoDateString;
    active: boolean;
    azureId: string;
    role: Role;
    organization: UserOrganizationResponseDTO | undefined;
}

export interface UserResponseDTO {
    userName: string;
    displayName: string;
    givenName: string;
    surname: string;
    creationDate: IsoDateString;
    lastUpdate: IsoDateString;
    active: boolean;
    azureId: string;
    role: Role;
}

export interface SubGroupResponseDTO {
    externalId: string;
    name: string;
    created: IsoDateString;
    createdBy: string;
    lastUpdated: IsoDateString;
    lastUpdatedBy: string;
}

export interface Status {
    readonly tag?: number;
    readonly isActive?: boolean;
    readonly isArchived?: boolean;
}

export interface StatusFSharpOption {
    value?: Status;
}

export interface SiteResponseDTO {
    externalId: string;
    organizationId: string;
    name: string;
    address: string | undefined;
    agileProjectContainerNumber: string | undefined;
    city: string | undefined;
    country: string | undefined;
    notes: string | undefined;
    salesForceProjectKey: string | undefined;
    stateProv: string | undefined;
    zip: string | undefined;
    created: IsoDateString;
    createdBy: string;
    lastUpdated: IsoDateString;
    lastUpdatedBy: string;
    firstName: string | undefined;
    lastName: string | undefined;
    phoneNumber: string | undefined;
    email: string | undefined;
    status: Status | undefined;
}

export interface EmailWhitelistResponseDTO {
    readonly email: string;
    readonly created: IsoDateString;
    readonly createdBy: string;
    readonly lastUpdated: IsoDateString;
    readonly lastUpdatedBy: string;
}

export interface SiteRequestDTO {
    organizationId: string;
    name?: string | undefined;
    address?: string | undefined;
    agileProjectContainerNumber?: string | undefined;
    city?: string | undefined;
    country?: string | undefined;
    notes?: string | undefined;
    salesForceProjectKey?: string | undefined;
    stateProv?: string | undefined;
    zip?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    phoneNumber?: string | undefined;
    email?: string | undefined;
    status?: Status | undefined;
}

export interface SubGroupUpdateRequestDTO {
    name?: string | undefined;
}

export interface SubGroupRequestDTO {
    name?: string | undefined;
    organizationId?: string;
}

export interface RoleFSharpOption {
    value?: Role;
}

export interface AdminUserRequestDTO {
    role?: Role | undefined;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}
